import { createSlice, createSelector } from "@reduxjs/toolkit";
import { ofType } from "redux-observable";
import { of } from "rxjs";
import { withLatestFrom, exhaustMap, map, catchError, shareReplay, filter, flatMap, switchMap } from "rxjs/operators";
import { getIsMobile } from "@nxplatform/helpers/helpers-pure";
import { SVGIcons } from "@nxplatform/platform-entities/icons";
import { selectMainRecommendedNonAuthEnabled, selectCategoryRecommendedEnabled } from "@nxplatform/platform-settings/platform-settings.selectors";
const CASINO_CATEGORY_FEATURE_KEY = "casinoCategory";
var CasinoFixedCategories = /* @__PURE__ */ ((CasinoFixedCategories2) => {
  CasinoFixedCategories2["all"] = "all";
  CasinoFixedCategories2["allTables"] = "all_tables";
  CasinoFixedCategories2["lobby"] = "lobby";
  CasinoFixedCategories2["lobbyLive"] = "lobby_live";
  CasinoFixedCategories2["popular"] = "popular";
  CasinoFixedCategories2["popularLive"] = "popular_live";
  CasinoFixedCategories2["popularSlots"] = "popular_slots";
  CasinoFixedCategories2["popularGames"] = "popular_games";
  CasinoFixedCategories2["new"] = "new";
  CasinoFixedCategories2["favorites"] = "favorites";
  CasinoFixedCategories2["myFavorites"] = "my-favorites";
  CasinoFixedCategories2["slots"] = "slots";
  CasinoFixedCategories2["roulette"] = "roulette";
  CasinoFixedCategories2["blackjack"] = "blackjack";
  CasinoFixedCategories2["baccarat"] = "baccarat";
  CasinoFixedCategories2["bonusBuy"] = "bonus_buy";
  CasinoFixedCategories2["jackpot"] = "jackpot";
  CasinoFixedCategories2["other"] = "other";
  CasinoFixedCategories2["poker"] = "poker";
  CasinoFixedCategories2["dropsAndWins"] = "drops_and_wins";
  CasinoFixedCategories2["dropsAndWinsLive"] = "drops_and_wins_live";
  CasinoFixedCategories2["dropsAndWinsWithTrait"] = "drops-and-wins";
  CasinoFixedCategories2["dropsAndWinsLiveWithTrait"] = "drops-and-wins-live";
  CasinoFixedCategories2["winter"] = "winter";
  CasinoFixedCategories2["WinterThree"] = "WinterThree";
  CasinoFixedCategories2["books"] = "books";
  CasinoFixedCategories2["kenoLotto"] = "keno-lotto";
  CasinoFixedCategories2["gameShowsLive"] = "game-shows";
  CasinoFixedCategories2["lastPlayed"] = "last-played";
  CasinoFixedCategories2["fishing"] = "fishing";
  CasinoFixedCategories2["recommended"] = "recommended";
  CasinoFixedCategories2["esports"] = "esports";
  CasinoFixedCategories2["sportbookmakers"] = "sportbookmakers";
  return CasinoFixedCategories2;
})(CasinoFixedCategories || {});
const casinoCategorySlug = "casino";
const liveCasinoCategorySlug = "live-casino";
const menuCasinoCategoryImages = {
  [
    "all"
    /* all */
  ]: SVGIcons.casino_all,
  [
    "all_tables"
    /* allTables */
  ]: SVGIcons.livecasino_all,
  [
    "lobby"
    /* lobby */
  ]: SVGIcons.casino_lobby,
  [
    "lobby_live"
    /* lobbyLive */
  ]: SVGIcons.livecasino_lobby,
  [
    "popular"
    /* popular */
  ]: SVGIcons.casino_popular,
  [
    "popular_live"
    /* popularLive */
  ]: SVGIcons.casino_popular,
  [
    "popular_slots"
    /* popularSlots */
  ]: SVGIcons.casino_popular,
  [
    "popular_games"
    /* popularGames */
  ]: SVGIcons.casino_popular,
  [
    "new"
    /* new */
  ]: SVGIcons.casino_new_games,
  [
    "favorites"
    /* favorites */
  ]: SVGIcons.casino_favorites,
  [
    "my-favorites"
    /* myFavorites */
  ]: SVGIcons.casino_favorites,
  [
    "slots"
    /* slots */
  ]: SVGIcons.casino_slots,
  [
    "roulette"
    /* roulette */
  ]: SVGIcons.casino_roulette,
  [
    "blackjack"
    /* blackjack */
  ]: SVGIcons.casino_blackjack,
  [
    "baccarat"
    /* baccarat */
  ]: SVGIcons.casino_baccarat,
  [
    "bonus_buy"
    /* bonusBuy */
  ]: SVGIcons.casino_bonus_buy,
  [
    "jackpot"
    /* jackpot */
  ]: SVGIcons.casino_jackpot,
  [
    "other"
    /* other */
  ]: SVGIcons.casino_other,
  [
    "poker"
    /* poker */
  ]: SVGIcons.casino_poker,
  [
    "drops_and_wins"
    /* dropsAndWins */
  ]: SVGIcons.casino_drops_and_wins,
  [
    "drops_and_wins_live"
    /* dropsAndWinsLive */
  ]: SVGIcons.casino_drops_and_wins,
  [
    "drops-and-wins"
    /* dropsAndWinsWithTrait */
  ]: SVGIcons.casino_drops_and_wins,
  [
    "drops-and-wins-live"
    /* dropsAndWinsLiveWithTrait */
  ]: SVGIcons.casino_drops_and_wins,
  [
    "winter"
    /* winter */
  ]: SVGIcons.winter,
  [
    "WinterThree"
    /* WinterThree */
  ]: SVGIcons.WinterThree,
  [
    "books"
    /* books */
  ]: SVGIcons.books,
  [
    "keno-lotto"
    /* kenoLotto */
  ]: SVGIcons.kenoLotto,
  [
    "last-played"
    /* lastPlayed */
  ]: SVGIcons.recentlyPlayed,
  [
    "fishing"
    /* fishing */
  ]: SVGIcons.fishing,
  [
    "recommended"
    /* recommended */
  ]: SVGIcons.casino_recommended
};
const fixedDevIds = {
  /* casino */
  all: "all",
  allTables: "all_tables",
  baccarat: "baccarat",
  bonusBuy: "bonus_buy",
  blackjack: "blackjack",
  brand: "brand",
  dropsAndWins: "drops_and_wins",
  dropsAndWinsWithTrait: "drops-and-wins",
  excludedGames: "excluded_games",
  fastGames: "fast_games",
  favorites: "favorites",
  halloween: "halloween",
  hot: "hot",
  hits: "hits",
  jackpot: "jackpot",
  keno: "keno",
  kenoAndLotto: "keno_and_lotto",
  lobby: "lobby",
  myFavorites: "my-favorites",
  new: "new",
  newGames: "new_games",
  other: "other",
  poker: "poker",
  popular: "popular",
  popularSlots: "popular_slots",
  roulette: "roulette",
  slots: "slots",
  fishing: "fishing",
  recommended: "recommended",
  esports: "esports",
  sportbookmakers: "sportbookmakers",
  /* live casino */
  baccaratLive: "baccarat_live",
  blackjackLive: "blackjack_live",
  brandLive: "brand_live",
  dropsAndWinsLive: "drops_and_wins_live",
  dropsAndWinsLiveWithTrait: "drops-and-wins-live",
  gameShowsLive: "game_shows",
  lobbyLive: "lobby_live",
  newLive: "new_live",
  otherLive: "other_live",
  pokerLive: "poker_live",
  popularLive: "popular_live",
  popularGamesLive: "popular_games",
  rouletteLive: "roulette_live",
  virtualSports: "virtual_sports",
  winter: "winter",
  WinterThree: "WinterThree",
  books: "books",
  kenoLotto: "keno_lotto",
  lastPlayed: "last-played"
};
var fontIconsType = /* @__PURE__ */ ((fontIconsType2) => {
  fontIconsType2[fontIconsType2["casino"] = 0] = "casino";
  fontIconsType2[fontIconsType2["platform"] = 1] = "platform";
  return fontIconsType2;
})(fontIconsType || {});
const casinoMenuLogoByDevIdFromSVG = {
  /* casino */
  [fixedDevIds.all]: SVGIcons.casino_all,
  [fixedDevIds.allTables]: SVGIcons.livecasino_all,
  [fixedDevIds.baccarat]: SVGIcons.casino_baccarat,
  [fixedDevIds.bonusBuy]: SVGIcons.casino_bonus_buy,
  [fixedDevIds.blackjack]: SVGIcons.casino_blackjack,
  [fixedDevIds.dropsAndWins]: SVGIcons.casino_drops_and_wins,
  [fixedDevIds.dropsAndWinsWithTrait]: SVGIcons.casino_drops_and_wins,
  [fixedDevIds.fastGames]: SVGIcons.casino_fast_games,
  [fixedDevIds.favorites]: SVGIcons.casino_favorites,
  [fixedDevIds.jackpot]: SVGIcons.casino_jackpot,
  [fixedDevIds.lobby]: SVGIcons.casino_lobby,
  [fixedDevIds.myFavorites]: SVGIcons.casino_favorites,
  [fixedDevIds.new]: SVGIcons.casino_new_games,
  [fixedDevIds.newGames]: SVGIcons.casino_new_games,
  [fixedDevIds.other]: SVGIcons.casino_other,
  [fixedDevIds.poker]: SVGIcons.casino_poker,
  [fixedDevIds.popular]: SVGIcons.casino_popular,
  [fixedDevIds.popularSlots]: SVGIcons.casino_popular,
  [fixedDevIds.roulette]: SVGIcons.casino_roulette,
  [fixedDevIds.slots]: SVGIcons.casino_slots,
  [fixedDevIds.virtualSports]: SVGIcons.vr,
  [fixedDevIds.winter]: SVGIcons.winter,
  [fixedDevIds.WinterThree]: SVGIcons.WinterThree,
  [fixedDevIds.fishing]: SVGIcons.fishing,
  [fixedDevIds.recommended]: SVGIcons.casino_recommended,
  [fixedDevIds.hot]: SVGIcons.hot,
  [fixedDevIds.esports]: SVGIcons.esports,
  [fixedDevIds.sportbookmakers]: SVGIcons.sportbookmakers,
  /* live casino */
  [fixedDevIds.baccaratLive]: SVGIcons.casino_baccarat,
  [fixedDevIds.blackjackLive]: SVGIcons.casino_blackjack,
  [fixedDevIds.dropsAndWinsLive]: SVGIcons.casino_drops_and_wins,
  [fixedDevIds.dropsAndWinsLiveWithTrait]: SVGIcons.casino_drops_and_wins,
  [fixedDevIds.lobbyLive]: SVGIcons.livecasino_lobby,
  [fixedDevIds.newLive]: SVGIcons.casino_new_games,
  [fixedDevIds.otherLive]: SVGIcons.casino_other,
  [fixedDevIds.pokerLive]: SVGIcons.casino_poker,
  [fixedDevIds.popularLive]: SVGIcons.casino_popular,
  [fixedDevIds.popularGamesLive]: SVGIcons.casino_popular,
  [fixedDevIds.rouletteLive]: SVGIcons.casino_roulette,
  [fixedDevIds.halloween]: SVGIcons.casino_halloween,
  [fixedDevIds.books]: SVGIcons.books,
  [fixedDevIds.kenoLotto]: SVGIcons.kenoLotto
};
const casinoMenuLogoByDevIdFromFont = {
  /* casino */
  [fixedDevIds.all]: "all",
  [fixedDevIds.allTables]: "all_tables",
  [fixedDevIds.baccarat]: "baccarat",
  [fixedDevIds.bonusBuy]: "bonus_buy",
  [fixedDevIds.blackjack]: "blackjack",
  [fixedDevIds.dropsAndWins]: "drops_and_wins",
  [fixedDevIds.dropsAndWinsWithTrait]: "drops_and_wins",
  [fixedDevIds.fastGames]: "fast_games",
  [fixedDevIds.favorites]: "favorites",
  [fixedDevIds.jackpot]: "jackpot",
  [fixedDevIds.lobby]: "lobby",
  [fixedDevIds.myFavorites]: "favorites",
  [fixedDevIds.new]: "new",
  [fixedDevIds.newGames]: "new",
  [fixedDevIds.other]: "other",
  [fixedDevIds.poker]: "poker",
  [fixedDevIds.popular]: "popular",
  [fixedDevIds.popularSlots]: "popular",
  [fixedDevIds.roulette]: "roulette",
  [fixedDevIds.slots]: "slots",
  [fixedDevIds.winter]: "winter",
  [fixedDevIds.WinterThree]: "WinterThree",
  [fixedDevIds.fishing]: "fishing",
  [fixedDevIds.recommended]: "recommended",
  [fixedDevIds.esports]: "esports",
  [fixedDevIds.sportbookmakers]: "sportbookmakers",
  /* live casino */
  [fixedDevIds.baccaratLive]: "baccarat",
  [fixedDevIds.blackjackLive]: "blackjack",
  [fixedDevIds.dropsAndWinsLive]: "drops_and_wins",
  [fixedDevIds.dropsAndWinsLiveWithTrait]: "drops_and_wins",
  [fixedDevIds.lobbyLive]: "lobby_live",
  [fixedDevIds.newLive]: "new",
  [fixedDevIds.otherLive]: "other",
  [fixedDevIds.pokerLive]: "poker",
  [fixedDevIds.popularLive]: "popular",
  [fixedDevIds.popularGamesLive]: "popular",
  [fixedDevIds.rouletteLive]: "roulette",
  [fixedDevIds.halloween]: "halloween",
  [fixedDevIds.books]: "books",
  [fixedDevIds.kenoLotto]: SVGIcons.kenoLotto
};
const getCasinoIconByDevId = (category, type) => {
  const { slug, dev_id } = category;
  const [currentDevId] = (dev_id || "").split("_extended");
  if (type === 1) {
    return casinoMenuLogoByDevIdFromSVG[currentDevId] || menuCasinoCategoryImages[slug] || currentDevId;
  }
  return casinoMenuLogoByDevIdFromFont[currentDevId] || currentDevId;
};
const getCasinoCategoryIconByDevId = (category, iconsMap) => {
  const [currentDevId] = (category.dev_id || "").split("_extended");
  return iconsMap[currentDevId] || currentDevId;
};
const initialCasinoCategoryState = {
  entities: [],
  liveEntities: [],
  loaded: false,
  isLoading: false,
  error: null,
  hotColdloaded: false,
  isHotColdLoading: false,
  categoryGames: {},
  activeCategory: null,
  baseCategory: null,
  activeProducerId: null,
  bonusGames: [],
  /** @deprecated use {@link bonusGamesById} instead. */
  bonusGamesById: {},
  coldGames: [],
  hotGames: [],
  lastPlayedGamesLive: [],
  lastPlayedGamesSpin: [],
  myFavoriteGames: [],
  myFavoriteGamesLive: [],
  categoryLoaded: {}
};
const myFavoritesSlug = "my-favorites";
const myFavoritesGameId = -2;
const casinoAllId = -1;
const lastPlayedSlug = "last-played";
const lastPlayedCategoryId = -3;
const recommendedId = -4;
const recommendedSlug = "recommended";
({
  dev_id: fixedDevIds.lobby
});
const casinoAllCategory = {
  id: casinoAllId,
  name: "Casino Menu_._Category_._All games",
  slug: "all",
  dev_id: fixedDevIds.all
};
const myFavoritesCategory = {
  id: myFavoritesGameId,
  name: "Casino Menu_._Category_._My Favorites",
  slug: myFavoritesSlug,
  dev_id: fixedDevIds.myFavorites
};
const lastPlayedCategory = {
  id: lastPlayedCategoryId,
  name: "Casino Menu_._Category_._Recently Played",
  slug: lastPlayedSlug,
  dev_id: fixedDevIds.lastPlayed
};
const recommendedCategory = {
  id: recommendedId,
  name: "Casino Menu_._Category_._For You",
  slug: recommendedSlug,
  dev_id: fixedDevIds.recommended
};
const isDropsAndWinsCategory = (game) => {
  return !!(game.categories && (game.categories.indexOf(
    "drops_and_wins"
    /* dropsAndWins */
  ) > -1 || game.categories.indexOf(
    "drops_and_wins_live"
    /* dropsAndWinsLive */
  ) > -1 || game.categories.indexOf(
    "drops-and-wins-live"
    /* dropsAndWinsLiveWithTrait */
  ) > -1 || game.categories.indexOf(
    "drops-and-wins"
    /* dropsAndWinsWithTrait */
  ) > -1));
};
const isCasinoAndLiveCategory = (dev_id) => {
  return dev_id === myFavoritesCategory.dev_id || dev_id === lastPlayedCategory.dev_id || dev_id === recommendedCategory.dev_id;
};
const casinoCategorySlice = createSlice({
  name: CASINO_CATEGORY_FEATURE_KEY,
  initialState: initialCasinoCategoryState,
  reducers: {
    getCasinoCategoryStart: (state) => {
      state.loaded = false;
    },
    getCasinoCategorySuccess: (state, action) => {
      state.loaded = true;
      state.entities = [...action.payload.data];
      const {
        auth,
        categoryRecentlyPlayedEnabled,
        recommendedEnabled,
        mainRecommendedNonAuthEnabled
      } = action.payload;
      if (auth) {
        if (categoryRecentlyPlayedEnabled) {
          state.entities.unshift(lastPlayedCategory);
        }
        state.entities.unshift(myFavoritesCategory);
      }
      if ((auth || !auth && mainRecommendedNonAuthEnabled) && recommendedEnabled) {
        state.entities.unshift(recommendedCategory);
      }
    },
    getCasinoCategoryFailure: (state, action) => {
      var _a;
      state.loaded = true;
      state.error = action.payload;
      state.isLoading = false;
      if ((_a = action == null ? void 0 : action.payload) == null ? void 0 : _a.id) {
        state.categoryLoaded[`${action.payload.id}`] = null;
      }
    },
    getHotColdGamesFailure: (state, action) => {
      state.hotColdloaded = true;
      state.error = action.payload;
      state.isHotColdLoading = false;
    },
    getLiveCasinoCategoryStart: (state) => {
      state.loaded = false;
    },
    getLiveCasinoCategorySuccess: (state, action) => {
      state.loaded = true;
      state.liveEntities = [...action.payload.data];
      const {
        auth,
        categoryRecentlyPlayedEnabled,
        recommendedEnabled,
        mainRecommendedNonAuthEnabled
      } = action.payload;
      if (auth) {
        if (categoryRecentlyPlayedEnabled) {
          state.liveEntities.unshift(lastPlayedCategory);
        }
        state.liveEntities.unshift(myFavoritesCategory);
      }
      if ((auth || !auth && mainRecommendedNonAuthEnabled) && recommendedEnabled) {
        state.liveEntities.unshift(recommendedCategory);
      }
    },
    getLiveCasinoCategoryFailure: (state, action) => {
      state.loaded = true;
      state.error = action.payload;
      state.isLoading = false;
    },
    getCasinoCategoryGamesStart: (state) => {
      state.isLoading = true;
    },
    getCasinoCategoryGamesSuccess: (state, action) => {
      var _a;
      const isMobile = getIsMobile();
      const games = [];
      const seenIds = /* @__PURE__ */ new Set();
      const {
        items,
        id: categoryId,
        pagination,
        has_live
      } = action.payload;
      const isExistingCategory = Object.keys(state.categoryGames).includes(
        `${categoryId}`
      );
      const currentGames = isExistingCategory ? ((_a = state.categoryGames[categoryId]) == null ? void 0 : _a.games) || [] : [];
      const { perPage, totalPages, totalCount } = pagination || {};
      items.forEach((game) => {
        const [, identifier2] = game.identifier.split(":");
        game.identifier2 = identifier2;
      });
      [...currentGames, ...items].forEach((game) => {
        if (!seenIds.has(game.id)) {
          seenIds.add(game.id);
          games.push(game);
        }
      });
      const categoryObject = {
        ...action.payload,
        per_page: perPage || isMobile ? "8" : "25",
        pages: totalPages || 1,
        total: totalCount || (items == null ? void 0 : items.length) || 1,
        games,
        game_count: (items == null ? void 0 : items.length) || 0
      };
      delete categoryObject.pagination;
      delete categoryObject.items;
      state.categoryGames[categoryId] = (categoryObject == null ? void 0 : categoryObject.game_count) && categoryObject;
      state.isLoading = false;
      state.categoryLoaded[categoryId] = true;
      if (categoryId === myFavoritesGameId) {
        if (has_live) {
          state.myFavoriteGamesLive = items;
        } else {
          state.myFavoriteGames = items;
        }
      }
    },
    setActiveCategory: (state, action) => {
      state.activeCategory = state.entities.find(
        (category) => category.slug === action.payload
      );
    },
    addCasinoFavoriteStart: () => {
    },
    addCasinoFavoriteSuccess: (state, action) => {
      state.myFavoriteGames = [...state.myFavoriteGames, action.payload];
    },
    addCasinoFavoriteFailure: (state, action) => {
    },
    removeFromFavoritesStart: () => {
    },
    removeFromFavoritesSuccess: (state, action) => {
      state.myFavoriteGames = state.myFavoriteGames.filter((game) => game.id !== action.payload.id);
    },
    removeFromFavoritesFailure: (state, action) => {
    },
    clearActiveCategory: (state) => {
      state.activeCategory = initialCasinoCategoryState.activeCategory;
    },
    clearActiveCategoryGames: (state, action) => {
      delete state.categoryGames[action.payload];
    },
    clearCategoryEntities: (state) => {
      state.categoryGames = initialCasinoCategoryState.categoryGames;
    },
    clearCasinoCategoryState: (state, action) => {
      var _a;
      state.activeCategory = initialCasinoCategoryState.activeCategory;
      state.categoryGames = initialCasinoCategoryState.categoryGames;
      state.baseCategory = initialCasinoCategoryState.baseCategory;
      if (!((_a = action.payload) == null ? void 0 : _a.partial)) {
        state.entities = initialCasinoCategoryState.entities;
      }
    },
    getBonusGamesListStart: (state, action) => {
      state.isLoading = true;
    },
    getBonusGamesListSuccess: (state, action) => {
      state.isLoading = false;
      if (action.payload.id) {
        state.bonusGamesById = {
          ...state.bonusGamesById,
          [action.payload.id]: action.payload.items
        };
      } else {
        state.bonusGames = action.payload.items;
      }
    },
    getHotGamesListStart: (state, action) => {
      state.isHotColdLoading = true;
    },
    getHotGamesListSuccess: (state, action) => {
      state.isHotColdLoading = false;
      state.hotGames = action.payload.items;
    },
    getColdGamesListStart: (state, action) => {
      state.isHotColdLoading = true;
    },
    getColdGamesListSuccess: (state, action) => {
      state.isHotColdLoading = false;
      state.coldGames = action.payload.items;
    },
    clearBonusGamesList: (state) => {
      state.bonusGames = initialCasinoCategoryState.bonusGames;
    },
    getLastPlayedGamesListStart: (state) => {
      state.isLoading = true;
    },
    getCasinoMyFavoritesStart: (state) => {
      state.isLoading = true;
    },
    getLastPlayedGamesListSuccess: (state, action) => {
      const { lastPlayedGamesLive, lastPlayedGamesSpin } = action.payload;
      state.isLoading = false;
      state.lastPlayedGamesLive = lastPlayedGamesLive;
      state.lastPlayedGamesSpin = lastPlayedGamesSpin;
    },
    getMyFavoriteGamesListSuccess: (state, action) => {
      const { myFavoriteGamesLive, myFavoriteGames } = action.payload;
      state.isLoading = false;
      state.myFavoriteGamesLive = myFavoriteGamesLive;
      state.myFavoriteGames = myFavoriteGames;
    },
    clearLoadedCategory: (state, action) => {
      state.categoryLoaded[`${action.payload}`] = false;
      delete state.categoryGames[action.payload];
    },
    getLastPlayedGamesListFailure: (state, action) => {
      state.error = action.payload;
      state.loaded = true;
    },
    clearLastPlayedGamesList: (state) => {
      state.lastPlayedGamesLive = initialCasinoCategoryState.lastPlayedGamesLive;
      state.lastPlayedGamesSpin = initialCasinoCategoryState.lastPlayedGamesSpin;
    },
    clearMyFavoritesGamesList: (state) => {
      state.myFavoriteGames = initialCasinoCategoryState.myFavoriteGames;
      state.myFavoriteGamesLive = initialCasinoCategoryState.myFavoriteGamesLive;
    }
  }
});
const casinoCategoryReducer = casinoCategorySlice.reducer;
const {
  getCasinoCategoryStart,
  getCasinoCategorySuccess,
  getCasinoCategoryFailure,
  getLiveCasinoCategoryStart,
  getLiveCasinoCategorySuccess,
  getLiveCasinoCategoryFailure,
  getCasinoCategoryGamesStart,
  getCasinoCategoryGamesSuccess,
  setActiveCategory,
  addCasinoFavoriteStart,
  addCasinoFavoriteSuccess,
  addCasinoFavoriteFailure,
  removeFromFavoritesStart,
  removeFromFavoritesSuccess,
  removeFromFavoritesFailure,
  clearActiveCategory,
  clearCasinoCategoryState,
  clearActiveCategoryGames,
  clearCategoryEntities,
  getBonusGamesListStart,
  getBonusGamesListSuccess,
  clearBonusGamesList,
  getLastPlayedGamesListStart,
  getLastPlayedGamesListSuccess,
  getLastPlayedGamesListFailure,
  clearLastPlayedGamesList,
  clearLoadedCategory,
  getCasinoMyFavoritesStart,
  clearMyFavoritesGamesList,
  getMyFavoriteGamesListSuccess,
  getHotGamesListStart,
  getHotGamesListSuccess,
  getColdGamesListStart,
  getColdGamesListSuccess,
  getHotColdGamesFailure
} = casinoCategorySlice.actions;
const getCasinoCategoryState = (rootState) => rootState[CASINO_CATEGORY_FEATURE_KEY];
const selectCasinoCategoryEntities = createSelector(
  getCasinoCategoryState,
  (s) => s.entities
);
const selectLiveCasinoCategoryEntities = createSelector(
  getCasinoCategoryState,
  (s) => s.liveEntities
);
const selectCasinoCategorySpinEntities = createSelector(
  getCasinoCategoryState,
  (s) => s.entities.filter((category) => category.id === myFavoritesGameId ? true : !category.is_live)
);
const selectCasinoCategoryLive = createSelector(
  getCasinoCategoryState,
  (s) => s.entities.filter((category) => isCasinoAndLiveCategory(category.dev_id) ? true : !!category.is_live)
);
const selectCasinoPopularCategory = createSelector(
  getCasinoCategoryState,
  (s) => s.entities.find((category) => category.slug === "popular")
);
const selectCasinoCategoryBySlug = createSelector(
  getCasinoCategoryState,
  (s, slug) => slug,
  (s, slug, isLive) => isLive,
  (s, slug, isLive) => {
    var _a;
    return (_a = isLive ? s == null ? void 0 : s.liveEntities : s == null ? void 0 : s.entities) == null ? void 0 : _a.find((category) => category.slug === slug);
  }
);
const selectCasinoCategoryBySlugAggregatedCategoryId = createSelector(
  getCasinoCategoryState,
  (s, slug) => slug,
  (s, slug, isLive) => isLive,
  (s, slug, isLive) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i;
    if (slug === casinoCategorySlug || slug === liveCasinoCategorySlug) {
      return ((_c = (_b = (_a = s == null ? void 0 : s.entities) == null ? void 0 : _a.find(
        (category) => {
          var _a2;
          return slug === casinoCategorySlug ? category.is_live === false : category.is_live === true && ((_a2 = category.aggregatedCategory) == null ? void 0 : _a2.isActive);
        }
      )) == null ? void 0 : _b.aggregatedCategory) == null ? void 0 : _c.categories[0]) || ((_e = (_d = s == null ? void 0 : s.entities) == null ? void 0 : _d.find(
        (category) => slug === casinoCategorySlug ? category.is_live === false : category.is_live === true
      )) == null ? void 0 : _e.id);
    }
    if (isLive) {
      return ((_g = (_f = s == null ? void 0 : s.entities) == null ? void 0 : _f.find(
        (category) => category.slug === slug && category.is_live === true
      )) == null ? void 0 : _g.id) || null;
    }
    if (!isLive) {
      return ((_i = (_h = s == null ? void 0 : s.entities) == null ? void 0 : _h.find(
        (category) => category.slug === slug && category.is_live === false
      )) == null ? void 0 : _i.id) || null;
    }
  }
);
const selectCasinoCategoryTopProducersBySlug = createSelector(
  getCasinoCategoryState,
  (s, slug) => slug,
  (s, slug, isLive) => isLive,
  (s, slug, isLive) => {
    var _a, _b, _c, _d, _e, _f;
    if (slug === casinoCategorySlug || slug === liveCasinoCategorySlug) {
      if (isLive) {
        return ((_b = (_a = s == null ? void 0 : s.liveEntities) == null ? void 0 : _a.find((category) => {
          var _a2;
          return slug === liveCasinoCategorySlug && !!category.is_live && ((_a2 = category.aggregatedCategory) == null ? void 0 : _a2.isActive);
        })) == null ? void 0 : _b.topProducers) || [];
      }
      if (!isLive) {
        return ((_d = (_c = s == null ? void 0 : s.entities) == null ? void 0 : _c.find((category) => {
          var _a2;
          return slug === casinoCategorySlug && !category.is_live && ((_a2 = category.aggregatedCategory) == null ? void 0 : _a2.isActive);
        })) == null ? void 0 : _d.topProducers) || [];
      }
    }
    return ((_f = (_e = s == null ? void 0 : s.entities) == null ? void 0 : _e.find(
      (category) => category.slug === slug && category.is_live === isLive
    )) == null ? void 0 : _f.topProducers) || [];
  }
);
const selectCasinoCategoryByDevId = createSelector(
  getCasinoCategoryState,
  (s, devId) => devId,
  (s, devId) => s.entities.find((category) => category.dev_id === devId)
);
const selectCasinoCategoryBySlugAndState = createSelector(
  getCasinoCategoryState,
  (s, slug) => slug,
  (s, slug, islive) => islive,
  (s, slug, isLive) => s.entities.find(
    (category) => category.slug === slug && category.is_live === isLive
  )
);
const selectCasinoCategoryGames = createSelector(
  getCasinoCategoryState,
  (s, id) => id || casinoAllId,
  (s, id) => s.categoryGames[id] || null
);
const selectCasinoCategoryGamesPages = createSelector(
  getCasinoCategoryState,
  (s, id) => id,
  (s, id) => {
    var _a;
    return ((_a = s.categoryGames[id]) == null ? void 0 : _a.pages) || null;
  }
);
const selectAllCasinoCategoryGames = createSelector(
  getCasinoCategoryState,
  (s) => Object.values(s.categoryGames)
);
const selectCasinoGamesByCategory = createSelector(
  selectCasinoCategoryGames,
  (gameEntity) => gameEntity ? gameEntity.games : []
);
const selectCasinoCategoryLoaded = createSelector(
  getCasinoCategoryState,
  (s) => s.loaded
);
const selectCasinoCategoryGamesLoaded = createSelector(
  getCasinoCategoryState,
  (s) => s.categoryLoaded
);
const selectHotColdGamesLoaded = createSelector(
  getCasinoCategoryState,
  (s) => s.hotColdloaded
);
const selectCurrentCategoryLoaded = createSelector(
  getCasinoCategoryState,
  (s, id) => id,
  // null in case of API fail
  (s, id) => !!s.categoryLoaded[id] || s.categoryLoaded[id] === null
);
const selectCasinoCategoryBase = createSelector(
  getCasinoCategoryState,
  (s) => s.baseCategory
);
const selectCasinoCategoriesGames = createSelector(
  getCasinoCategoryState,
  (s) => s.categoryGames
);
const selectCasinoActiveCategory = createSelector(
  getCasinoCategoryState,
  (s) => s.activeCategory
);
const selectCasinoCategoryError = createSelector(
  getCasinoCategoryState,
  (s) => s.error
);
const selectIsCategoryGamesLoading = createSelector(
  getCasinoCategoryState,
  (s) => s.isLoading
);
const selectIsHotColdGamesLoading = createSelector(
  getCasinoCategoryState,
  (s) => s.isHotColdLoading
);
const selectCasinoBonusGamesList = createSelector(
  getCasinoCategoryState,
  (s, id) => id,
  (s, id) => id ? s.bonusGamesById[id] : s.bonusGames
  /** @deprecated use {@link bonusGamesById} instead. */
);
const selectCasinoHotGamesList = createSelector(
  getCasinoCategoryState,
  (s) => s.hotGames
);
const selectCasinoColdGamesList = createSelector(
  getCasinoCategoryState,
  (s) => s.coldGames
);
const selectLastPlayedGamesLive = createSelector(
  getCasinoCategoryState,
  (s) => s.lastPlayedGamesLive
);
const selectLastPlayedGamesSpin = createSelector(
  getCasinoCategoryState,
  (s) => s.lastPlayedGamesSpin
);
const selectMyFavoriteGamesLiveIsEmpty = createSelector(
  getCasinoCategoryState,
  (s) => {
    var _a;
    return !((_a = s.myFavoriteGamesLive) == null ? void 0 : _a.length);
  }
);
const selectMyFavoriteGamesIsEmpty = createSelector(
  getCasinoCategoryState,
  (s) => {
    var _a;
    return !((_a = s.myFavoriteGames) == null ? void 0 : _a.length);
  }
);
const selectLastPlayedGamesLiveIsEmpty = createSelector(
  selectLastPlayedGamesLive,
  (games) => !(games == null ? void 0 : games.length)
);
const selectLastPlayedGamesSpinIsEmpty = createSelector(
  selectLastPlayedGamesSpin,
  (games) => !(games == null ? void 0 : games.length)
);
const selectMyFavoritesGamesIsNotLoaded = createSelector(
  getCasinoCategoryState,
  (s) => {
    return !s.categoryLoaded[myFavoritesGameId];
  }
);
const selectFavoriteGamesIsEmpty = createSelector(
  getCasinoCategoryState,
  (s) => {
    return !s.categoryGames[myFavoritesGameId];
  }
);
const fetchCasinoCategoriesEpic = (action$, state$, { Api }) => action$.pipe(
  ofType(getCasinoCategoryStart.type),
  withLatestFrom(state$),
  exhaustMap(([action, state]) => Api.casinoSession.getCategories(action.payload).pipe(
    map((data) => getCasinoCategorySuccess({
      data,
      auth: !!action.payload.auth,
      categoryRecentlyPlayedEnabled: action.payload.categoryRecentlyPlayedEnabled,
      recommendedEnabled: selectCategoryRecommendedEnabled(state),
      mainRecommendedNonAuthEnabled: selectMainRecommendedNonAuthEnabled(state)
    })),
    catchError((err) => of(getCasinoCategoryFailure(err))),
    shareReplay({ refCount: true })
  ))
);
const fetchCasinoCategories = (params) => ({
  type: getCasinoCategoryStart.type,
  payload: params
});
const fetchLiveCasinoCategoriesEpic = (action$, state$, { Api }) => action$.pipe(
  ofType(getLiveCasinoCategoryStart.type),
  withLatestFrom(state$),
  exhaustMap(([action, state]) => Api.casinoSession.getCategories(action.payload).pipe(
    map((data) => getLiveCasinoCategorySuccess({
      data,
      auth: !!action.payload.auth,
      categoryRecentlyPlayedEnabled: action.payload.categoryRecentlyPlayedEnabled,
      recommendedEnabled: selectCategoryRecommendedEnabled(state),
      mainRecommendedNonAuthEnabled: selectMainRecommendedNonAuthEnabled(state)
    })),
    catchError((err) => of(getLiveCasinoCategoryFailure(err))),
    shareReplay({ refCount: true })
  ))
);
const fetchLiveCasinoCategories = (params) => ({
  type: getLiveCasinoCategoryStart.type,
  payload: params
});
const fetchCasinoGamesByCategoryEpic = (action$, state$, { Api }) => action$.pipe(
  ofType(getCasinoCategoryGamesStart.type),
  filter((action) => action.payload.category_id !== recommendedId),
  flatMap((action) => Api.casinoSession.getGames(action.payload).pipe(
    map((data) => Object.assign(data, { id: action.payload.category_id || casinoAllId, has_live: action.payload.has_live })),
    map((data) => getCasinoCategoryGamesSuccess(data)),
    catchError((err) => of(getCasinoCategoryFailure({ err, id: action.payload.category_id })))
  ))
);
const fetchCasinoGamesByCategory = (params) => ({
  type: getCasinoCategoryGamesStart.type,
  payload: params
});
const addCasinoFavoriteEpic = (action$, state$, { Api }) => action$.pipe(
  ofType(addCasinoFavoriteStart.type),
  exhaustMap((action) => Api.casinoSession.addToFavorites(action.payload.id).pipe(
    map(() => addCasinoFavoriteSuccess(action.payload)),
    catchError((err) => of(addCasinoFavoriteFailure(err)))
  ))
);
const addToFavorites = (game) => ({
  type: addCasinoFavoriteStart.type,
  payload: game
});
const removeFromFavoritesEpic = (action$, state$, { Api }) => action$.pipe(
  ofType(removeFromFavoritesStart.type),
  exhaustMap((action) => Api.casinoSession.removeFromFavorites(
    action.payload.id
  ).pipe(
    map(() => removeFromFavoritesSuccess(action.payload)),
    catchError((err) => of(removeFromFavoritesFailure(err)))
  ))
);
const removeFromFavorites = (game) => ({
  type: removeFromFavoritesStart.type,
  payload: game
});
const fetchBonusGamesListEpic = (action$, state$, { Api }) => action$.pipe(
  ofType(getBonusGamesListStart.type),
  flatMap((action) => Api.casinoSession.getGames({
    gamesIds: action.payload.gamesIds
  }).pipe(
    map((data) => Object.assign(data, { id: action.payload.id })),
    map((data) => getBonusGamesListSuccess(data)),
    catchError((err) => of(getCasinoCategoryFailure(err)))
  ))
);
const fetchBonusGamesList = (params) => ({
  type: getBonusGamesListStart.type,
  payload: params
});
const fetchHotGamesListEpic = (action$, state$, { Api }) => action$.pipe(
  ofType(getHotGamesListStart.type),
  flatMap((action) => Api.casinoSession.getGames(action.payload).pipe(
    map((data) => getHotGamesListSuccess(data)),
    catchError((err) => of(getHotColdGamesFailure(err)))
  ))
);
const fetchHotGamesList = (params) => ({
  type: getHotGamesListStart.type,
  payload: params
});
const fetchColdGamesListEpic = (action$, state$, { Api }) => action$.pipe(
  ofType(getColdGamesListStart.type),
  flatMap((action) => Api.casinoSession.getGames(action.payload).pipe(
    map((data) => getColdGamesListSuccess(data)),
    catchError((err) => of(getHotColdGamesFailure(err)))
  ))
);
const fetchColdGamesList = (params) => ({
  type: getColdGamesListStart.type,
  payload: params
});
const fetchLastPlayedGamesLastEpic = (action$, state$, { Api }) => action$.pipe(
  ofType(getCasinoMyFavoritesStart.type),
  switchMap((action) => Api.casinoSession.getGamesLastPlayed(action.payload).pipe(
    map((data) => {
      return getLastPlayedGamesListSuccess({
        lastPlayedGamesLive: [...data.items].filter((casino) => casino.has_live),
        lastPlayedGamesSpin: [...data.items].filter((casino) => !casino.has_live)
      });
    }),
    catchError((error) => of(getLastPlayedGamesListFailure(error)))
  ))
);
const fetchLastPlayedGames = (payload) => ({
  type: getLastPlayedGamesListStart.type,
  payload
});
const fetchCasinoMyFavoritesGamesEpic = (action$, state$, { Api }) => action$.pipe(
  ofType(getCasinoMyFavoritesStart.type),
  switchMap((action) => Api.casinoSession.getMyFavoritesGames(action.payload).pipe(
    map((data) => {
      return getMyFavoriteGamesListSuccess({
        myFavoriteGamesLive: [...data.items].filter((casino) => casino.has_live),
        myFavoriteGames: [...data.items].filter((casino) => !casino.has_live)
      });
    }),
    catchError((error) => of(getCasinoCategoryFailure(error)))
  ))
);
const fetchCasinoMyFavoritesGames = (params) => ({
  type: getCasinoMyFavoritesStart.type,
  payload: params
});
export {
  CASINO_CATEGORY_FEATURE_KEY,
  CasinoFixedCategories,
  addCasinoFavoriteEpic,
  addCasinoFavoriteFailure,
  addCasinoFavoriteStart,
  addCasinoFavoriteSuccess,
  addToFavorites,
  casinoAllCategory,
  casinoAllId,
  casinoCategoryReducer,
  casinoCategorySlice,
  casinoCategorySlug,
  clearActiveCategory,
  clearActiveCategoryGames,
  clearBonusGamesList,
  clearCasinoCategoryState,
  clearCategoryEntities,
  clearLastPlayedGamesList,
  clearLoadedCategory,
  clearMyFavoritesGamesList,
  fetchBonusGamesList,
  fetchBonusGamesListEpic,
  fetchCasinoCategories,
  fetchCasinoCategoriesEpic,
  fetchCasinoGamesByCategory,
  fetchCasinoGamesByCategoryEpic,
  fetchCasinoMyFavoritesGames,
  fetchCasinoMyFavoritesGamesEpic,
  fetchColdGamesList,
  fetchColdGamesListEpic,
  fetchHotGamesList,
  fetchHotGamesListEpic,
  fetchLastPlayedGames,
  fetchLastPlayedGamesLastEpic,
  fetchLiveCasinoCategories,
  fetchLiveCasinoCategoriesEpic,
  fixedDevIds,
  fontIconsType,
  getBonusGamesListStart,
  getBonusGamesListSuccess,
  getCasinoCategoryFailure,
  getCasinoCategoryGamesStart,
  getCasinoCategoryGamesSuccess,
  getCasinoCategoryIconByDevId,
  getCasinoCategoryStart,
  getCasinoCategoryState,
  getCasinoCategorySuccess,
  getCasinoIconByDevId,
  getCasinoMyFavoritesStart,
  getColdGamesListStart,
  getColdGamesListSuccess,
  getHotColdGamesFailure,
  getHotGamesListStart,
  getHotGamesListSuccess,
  getLastPlayedGamesListFailure,
  getLastPlayedGamesListStart,
  getLastPlayedGamesListSuccess,
  getLiveCasinoCategoryFailure,
  getLiveCasinoCategoryStart,
  getLiveCasinoCategorySuccess,
  getMyFavoriteGamesListSuccess,
  initialCasinoCategoryState,
  isDropsAndWinsCategory,
  lastPlayedCategory,
  lastPlayedCategoryId,
  lastPlayedSlug,
  liveCasinoCategorySlug,
  menuCasinoCategoryImages,
  myFavoritesCategory,
  myFavoritesGameId,
  myFavoritesSlug,
  recommendedCategory,
  recommendedId,
  recommendedSlug,
  removeFromFavorites,
  removeFromFavoritesEpic,
  removeFromFavoritesFailure,
  removeFromFavoritesStart,
  removeFromFavoritesSuccess,
  selectAllCasinoCategoryGames,
  selectCasinoActiveCategory,
  selectCasinoBonusGamesList,
  selectCasinoCategoriesGames,
  selectCasinoCategoryBase,
  selectCasinoCategoryByDevId,
  selectCasinoCategoryBySlug,
  selectCasinoCategoryBySlugAggregatedCategoryId,
  selectCasinoCategoryBySlugAndState,
  selectCasinoCategoryEntities,
  selectCasinoCategoryError,
  selectCasinoCategoryGames,
  selectCasinoCategoryGamesLoaded,
  selectCasinoCategoryGamesPages,
  selectCasinoCategoryLive,
  selectCasinoCategoryLoaded,
  selectCasinoCategorySpinEntities,
  selectCasinoCategoryTopProducersBySlug,
  selectCasinoColdGamesList,
  selectCasinoGamesByCategory,
  selectCasinoHotGamesList,
  selectCasinoPopularCategory,
  selectCurrentCategoryLoaded,
  selectFavoriteGamesIsEmpty,
  selectHotColdGamesLoaded,
  selectIsCategoryGamesLoading,
  selectIsHotColdGamesLoading,
  selectLastPlayedGamesLive,
  selectLastPlayedGamesLiveIsEmpty,
  selectLastPlayedGamesSpin,
  selectLastPlayedGamesSpinIsEmpty,
  selectLiveCasinoCategoryEntities,
  selectMyFavoriteGamesIsEmpty,
  selectMyFavoriteGamesLiveIsEmpty,
  selectMyFavoritesGamesIsNotLoaded,
  setActiveCategory
};
